import { Button } from "reactstrap";
import React from "react"; // needed for JSX in `Cell`

const TransactionColumns = (onEdit, onDelete) => [
  {
    Header: "Title",
    accessor: "title",
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Notes",
    accessor: "notes",
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Payment Type",
    accessor: "payment_type",
    disableFilters: true,
    filterable: true,
    Cell: ({ value }) => (value === 1 ? "Cash" : value === 2 ? "Online" : "Other"),
  },
  {
    Header: "Status",
    accessor: "transaction_status",
    disableFilters: true,
    filterable: false,
    Cell: ({ value }) => (
      <span
        className={`badge ${
          value === 1 ? "bg-success" : "bg-warning"
        }`}
      >
        {value === 1 ? "Approved" : "Cancelled"}
      </span>
    )
  },
  {
    Header: "Transcation Type",
    accessor: "transaction_type",
    disableFilters: true,
    filterable: false,
    Cell: ({ value }) => (value === 1 ? "Income" : value === 2 ? "Expense" : "Other"),
  },
  {
    Header: "Date",
    accessor: "received_date",
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Amount",
    accessor: "amount",
    disableFilters: true,
    filterable: true,
  },
  {
    Header: "Actions",
    accessor: "action",
    disableSortBy: true,
    disableFilters: true,
    filterable: false,
    Cell: ({ row }) => (
      <div className="d-flex gap-2">
          <Button color="primary" size="sm" onClick={() => onEdit(row.original)}>
            <i className="mdi mdi-pencil"></i>
          </Button>
          <Button color="danger" size="sm" onClick={() => onDelete(row.original)}>
            <i className="mdi mdi-delete"></i>
          </Button>
        </div>
    ),
  },
];

export default TransactionColumns;


